import { Injectable } from '@angular/core';
import * as admin from '../subnav/admin.dat.json';
import * as community from '../subnav/community.dat.json';
import * as data from '../subnav/data.dat.json';
import * as map from '../subnav/map.dat.json';
import * as org from '../subnav/org.dat.json';

export const dataArgs = [
  "hasEditableRecords",
  "isOwner",
  "isRaster",
  "isExportable",
  "isLayerEditor",
  "hasRecords",
  "isVector",
  "canCreate",
];
export const communityArgs = [
  "groupId",
  "groupStatus",
  "contactId"
]
export const mapArgs = [
  "isMapEditor",
  "isMapEmbeddable",
  "isMapOwner",
  "mapId"
]

export type SubNavTarget = 'admin' | 'community' | 'data' | 'map' | 'org';


@Injectable({
  providedIn: 'root'
})
export class DmiSubnavService {

  constructor() { }

  GetSubNav(target: SubNavTarget) {
    switch (target) {
      case 'admin':
        return admin;
      case 'community':
        return community;
      case 'data':
        return data;
      case 'map':
        return map;
      case 'org':
        return org;
    }
  }


}
